$(function() {
  var $sangyouWrap = $('.industry');   // page id
  var $tabs = $sangyouWrap.find('.tabs');   // 地図表示切り替え用タブ
  var $maps = $sangyouWrap.find('.maps');   // 切り替え対象の地図全体
  
  $tabs.find('a').on('click', function() {
    var $this = $(this);

    // class: active, next消去
    // active --> 表示対象要素
    // next --> border付与対象要素
    $tabs.find('li').removeClass('active next');

    // 地図非表示
    $maps.find('img').removeClass('active');

    // class: active付与
    $this.parents('li').addClass('active');

    // 表示地図画像変更
    var activeMapClass = $this.attr('data-tab-name');
    $maps.find('img').each(function() {
      if($(this).hasClass(activeMapClass)) {
        $(this).addClass('active');
      }
    });

    for(var i = 0; i < $maps.find('img').length; i++) {
      if((i != 1) && ($maps.find('img').eq(i).hasClass('active'))) {
        $tabs.find('li').eq((i + 1) % 3).addClass('next');
      }
    }
  });
});